import type {CanvasTextBlock} from '../types';
import type {BlockRendererProps} from './types';

export const TextBlock = ({block}: BlockRendererProps<CanvasTextBlock>) => {
  return (
    <p className="whitespace-pre-line leading-relaxed text-muted-foreground">
      {block.body}
    </p>
  );
};

export const textBlockConfig = {
  component: TextBlock,
  isEmpty: (block: CanvasTextBlock) => !block.body?.trim(),
};
